// Signatuurblok heat_timer: demo-klok die aftelt tot het apparaat klaar is. Teksten via data-attributen.

class SignatureHeat extends HTMLElement {
  connectedCallback() {
    if (this.button) return;
    this.button = this.querySelector('[data-heat-start]');
    this.ring = this.querySelector('[data-heat-ring]');
    this.arc = this.querySelector('[data-heat-arc]');
    this.number = this.querySelector('[data-heat-number]');
    this.unit = this.querySelector('[data-heat-unit]');
    this.status = this.querySelector('[data-heat-status]');
    this.seconds = Number(this.dataset.seconds) || 0;
    if (!this.button || !this.ring || !this.seconds) return;
    this.button.addEventListener('click', () => this.start());
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
  }

  start() {
    const d = this.dataset;
    cancelAnimationFrame(this.frame);
    this.ring.classList.remove('is-done');
    this.ring.classList.add('is-running');
    this.button.textContent = d.tRunning;
    if (this.unit) this.unit.textContent = d.tUnit;
    if (this.status) this.status.textContent = d.tRunning;

    const started = performance.now();
    const tick = (now) => {
      const left = Math.max(0, this.seconds - (now - started) / 1000);
      if (this.number) this.number.textContent = String(Math.ceil(left));
      if (this.arc) this.arc.style.strokeDashoffset = String((left / this.seconds) * 100);
      if (left > 0) {
        this.frame = requestAnimationFrame(tick);
        return;
      }
      this.ring.classList.remove('is-running');
      this.ring.classList.add('is-done');
      if (this.unit) this.unit.textContent = d.tDone;
      if (this.status) this.status.textContent = d.tDone;
      this.button.textContent = d.tAgain;
    };
    this.frame = requestAnimationFrame(tick);
  }
}

if (!customElements.get('signature-heat')) customElements.define('signature-heat', SignatureHeat);
